/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_LecturerInputs */

const en__field_lecturer = /** @type {(inputs: _Field_LecturerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecturer`)
};

const de__field_lecturer = /** @type {(inputs: _Field_LecturerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dozent`)
};

/**
* | output |
* | --- |
* | "Lecturer" |
*
* @param {_Field_LecturerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_lecturer = /** @type {((inputs?: _Field_LecturerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_LecturerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_lecturer(inputs)
	return de__field_lecturer(inputs)
});